<template>
  <v-container grid-list-xl text-xs-center style="height: 100%">
    <v-layout row wrap align-center justify-center style="height: 100%">
      <v-flex xs5 offset-xs1>
        <v-flex xs12 style="display: flex; align-items:center; justify-content:center">
          <v-avatar size="30px">
            <img src="@/assets/YakshofLogo.png"/>
          </v-avatar>
          <span class="headline ml-2" style="line-height: 40px">Yakshof Data Slicer</span>
        </v-flex>
        <v-divider class="mt-2 mb-4"></v-divider>
        <form>
          <v-text-field ref="email" placeholder=" " v-model="email" :error-messages="emailErrorMsgs" label="Email" required @input="$v.email.$touch()" @blur="$v.email.$touch()"></v-text-field>
          <v-text-field ref="password" placeholder=" " v-model="password" autocomplete v-on:keyup.enter='submit' type="password" :error-messages="passwordErrorMsgs" label="Password" required @input="$v.password.$touch()" @blur="$v.password.$touch()"></v-text-field>
          <v-btn @click="submit">submit</v-btn>
          <v-btn @click="clear">clear</v-btn>
        </form>
        <v-divider class="mt-4"></v-divider>
        <v-flex xs12>
          <div class="caption">©2018 All Rights Reserved.</div>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import underscore from 'underscore'
  import vh, { email, password } from '@/helpers/validators'
  import { mapMutations, mapGetters } from 'vuex'
  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    validations: {
      email: vh.vrules(email),
      password: vh.vrules(password)
    },
    computed: {
      ...mapGetters('auth', ['isLoggedIn']),
      emailErrorMsgs () {
        if (this.$v.email.$dirty) {
          return vh.vmsg(this.$v.email, email)
        } else {
          return []
        }
      },
      passwordErrorMsgs () {
        if (this.$v.password.$dirty) {
          return vh.vmsg(this.$v.password, password)
        } else {
          return []
        }
      }
    },
    methods: {
      ...mapMutations('notification', ['notify']),
      submit () {
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.login()
      },
      clear () {
        this.$v.$reset()
        this.email = ''
        this.password = ''
      },
      async login () {
        try {
          await this.$store.dispatch('auth/login', { ...this.$data })
          if (this.$route.query && this.$route.query.redirect) {
            this.$router.push({ path: this.$route.query.redirect, query: underscore.omit(this.$route.query, 'redirect') })
          } else {
            this.$router.push({ path: '/home', query: underscore.omit(this.$route.query, 'redirect') })
          }
        } catch (e) {
          this.notify({message: 'You have failed to log in. Try again with other credentials.', show: true})
        }
      }
    },
    created: function () {
      this.$store.dispatch('auth/logout')
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Login.vue